import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../services/supabaseClient'

export default function LinkAccount() {
  const [schoolId, setSchoolId] = useState('')
  const [studentCode, setStudentCode] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const navigate = useNavigate()

  async function handleSubmit(e) {
    e.preventDefault()
    setError('')
    setSuccess('')
    if (!schoolId || !studentCode) {
      setError('يرجى إدخال رقم المدرسة ورمز الطالب')
      return
    }
    setLoading(true)
    const { error: rpcError } = await supabase.rpc('link_student_to_current_user', {
      p_school_id: Number(schoolId),
      p_student_code: studentCode.trim(),
    })
    setLoading(false)
    if (rpcError) {
      setError(rpcError.message || 'حدث خطأ أثناء ربط الحساب')
      return
    }
    setSuccess('تم ربط حساب Google بحساب الطالب بنجاح')
    setTimeout(() => {
      navigate('/', { replace: true })
    }, 800)
  }

  return (
    <div dir="rtl" style={{ maxWidth: 480, margin: '2rem auto', padding: 16 }}>
      <h1 style={{ marginBottom: 12 }}>ربط حساب الطالب</h1>
      <p style={{ marginBottom: 12 }}>
        يتم استخدام هذه الخطوة مرة واحدة فقط لربط حساب Google بالطالب الصحيح
        في النظام.
      </p>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: 'block', marginBottom: 4 }}>رقم المدرسة (school_id)</label>
          <input
            type="number"
            value={schoolId}
            onChange={e => setSchoolId(e.target.value)}
            style={{ width: '100%', padding: 8, borderRadius: 8, border: '1px solid #e5e7eb' }}
          />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: 'block', marginBottom: 4 }}>رمز الطالب (code)</label>
          <input
            type="text"
            value={studentCode}
            onChange={e => setStudentCode(e.target.value)}
            style={{ width: '100%', padding: 8, borderRadius: 8, border: '1px solid #e5e7eb' }}
          />
        </div>
        {error && (
          <div style={{ color: '#b91c1c', marginBottom: 12 }}>{error}</div>
        )}
        {success && (
          <div style={{ color: '#15803d', marginBottom: 12 }}>{success}</div>
        )}
        <button
          type="submit"
          disabled={loading}
          style={{
            width: '100%',
            padding: 10,
            borderRadius: 8,
            border: 'none',
            cursor: 'pointer',
            backgroundColor: loading ? '#9ca3af' : '#2563eb',
            color: '#fff',
            fontWeight: 600,
          }}
        >
          {loading ? 'جاري الربط...' : 'ربط الحساب الآن'}
        </button>
      </form>
    </div>
  )
}
